import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PartCode extends Component {
  constructor(props) {
    super(props);
    this.handlePartQuantityChange = this.handlePartQuantityChange.bind(this);
  }

  handlePartQuantityChange(event, data) {
    const {order} = this.props;
    this.props.editSuggestedOrderPartQuantity(data.value, order);
  }

  render() {
    const {order, index} = this.props;

    return (
      <Input required
        id={`partQuantity${index}`}
        className='input-part-quantity'
        autoFocus={order.special}
        size='mini'
        name='partQuantity'
        type='number'
        min='1'
        max='99999'
        disabled={order.deleted}
        value={order.partQuantity}
        placeholder='Cant.'
        onChange={this.handlePartQuantityChange}
      />
    );
  }
}

const mapStateToProps = (state) => ({});

const {
  editSuggestedOrderPartQuantity,
} = Actions;

export default connect(mapStateToProps, {
  editSuggestedOrderPartQuantity,
})(PartCode);
